/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Dialog_ConsentInputs */



/**
* | output |
* | --- |
* | "Let the person you are talking to know that Wundo is taking notes." |
*
* @param {Meeting_Offline_Dialog_ConsentInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_dialog_consent = /** @type {((inputs?: Meeting_Offline_Dialog_ConsentInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Dialog_ConsentInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Laat je gesprekspartner weten dat Wundo meeschrijft.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prévenez votre interlocuteur que Wundo prend des notes.")
	return /** @type {LocalizedString} */ ("Let the person you are talking to know that Wundo is taking notes.")
});